<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-layout row wrap class="pr-3 mb-2">
        <v-flex class="pb-0">
          <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
            UPLOAD BI DOCUMENT
          </h2>
          <v-breadcrumbs
            class="
              px-0
              subtitle-2
              mt-2
              py-0
              breadcrumbs-items
              custom-breadcrumbs
            "
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-xl fluid class="px-0">
      <v-card class="rounded-10 elevation-card">
        <v-card-title class="primary py-3 px-2 white--text">
          <span
            class="font-weight-700 fs-16 lh-16 pl-1"
            style="align-self: center"
          >
            UPLOAD BI DOCUMENT
          </span>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-card-text class="px-5 pt-5">
            <v-layout row wrap>
              <v-col class="pl-1 border-dot mx-1">
                <label class="textblack--text fs-12">Upload IO SAP</label>
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterComplete"
                  @vdropzone-reset="fileRemoved()"
                ></vue-dropzone>
                <v-btn
                  text
                  block
                  color="orangeWarning"
                  small
                  @click="getTemplateUpload('sap')"
                  ><v-icon>mdi-download</v-icon>Download Template</v-btn
                >
              </v-col>
              <v-col class="pl-1 border-dot mx-1">
                <label class="textblack--text fs-12">Upload Source PO BI</label>
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzonePO"
                  id="dropzonePO"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterCompleteBI($event, 0)"
                  @vdropzone-reset="fileRemovedBI(0)"
                ></vue-dropzone>
                <v-btn
                  text
                  block
                  color="orangeWarning"
                  @click="getTemplateUpload('po')"
                  small
                  ><v-icon>mdi-download</v-icon>Download Template</v-btn
                >
              </v-col>
              <v-col class="pl-1 border-dot mx-1">
                <label class="textblack--text fs-12"
                  >Upload Source Non-PO BI</label
                >
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzoneNonPO"
                  id="dropzoneNonPO"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterCompleteBI($event, 2)"
                  @vdropzone-reset="fileRemovedBI(2)"
                ></vue-dropzone>
                <v-btn
                  text
                  block
                  color="orangeWarning"
                  @click="getTemplateUpload('non-po')"
                  small
                  ><v-icon>mdi-download</v-icon>Download Template</v-btn
                >
              </v-col>
              <v-col class="px-1 border-dot mx-1">
                <label class="textblack--text fs-12"
                  >Upload PO Delivery Complete</label
                >
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzonePOCompleted"
                  id="dropzonePOCompleted"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterPOCompleted($event, 3)"
                  @vdropzone-reset="fileRemovedPO()"
                ></vue-dropzone>
                <v-btn
                  text
                  block
                  color="orangeWarning"
                  small
                  @click="getTemplateUpload('po-delivery')"
                  ><v-icon>mdi-download</v-icon>Download Template</v-btn
                >
              </v-col>
              <v-flex xs12 class="px-1">
                <v-btn
                  class="secondblue white--text"
                  block
                  @click="uploadAll()"
                  id="uploadAll"
                  >Upload</v-btn
                >
              </v-flex>
              <v-flex xs12>
                <div class="px-0" v-if="isError">
                  <span class="font-weight-medium subtitle-1 darkblue--text">
                    Please check the invalid IO SAP data below.
                  </span>
                  <v-col sm="12" class="px-0 mb-3">
                    <template>
                      <v-simple-table class="spending-table">
                        <template v-slot:default>
                          <thead width="100%">
                            <tr>
                              <th class="f-14 text-left">Budget Owner</th>
                              <th class="f-14 text-left">Code</th>
                            </tr>
                          </thead>
                          <VuePerfectScrollbar
                            class="drawer-menu--scroll"
                            :settings="scrollSettings"
                          >
                            <tbody width="100%">
                              <tr
                                v-for="(item, index) in itemsNotFound"
                                :key="index"
                              >
                                <td>{{ item.budgetOwner || '-' }}</td>
                                <td>{{ item.navCode || '-' }}</td>
                              </tr>
                            </tbody>
                          </VuePerfectScrollbar>
                        </template>
                      </v-simple-table>
                    </template>
                    <hr class="hr-line mb-5 mt-5" style="" />
                  </v-col>
                </div>
                <div class="px-0" v-if="isErrorPo">
                  <span class="font-weight-medium subtitle-1 darkblue--text">
                    Please check the invalid PO BI data below.
                  </span>
                  <v-col sm="12" class="px-0">
                    <template>
                      <v-simple-table fixed-header class="table-taxonomy">
                        <template v-slot:default>
                          <VuePerfectScrollbar
                            class="drawer-menu--scroll"
                            :settings="scrollSettings"
                          >
                            <thead>
                              <tr>
                                <th class="f-14">Controlling Area</th>
                                <th class="f-14">Internal Order</th>
                                <th class="f-14">PO Deletion Flag</th>
                                <th class="f-14">PO Number</th>
                                <th class="f-14">PO Date</th>
                                <th class="f-14">Vendor Name</th>
                                <th class="f-14">PO Line Item Text</th>
                                <th class="f-14">PO Release Status</th>
                                <th class="f-14">PO Release Flag</th>
                                <th class="f-14">Release Indicator-Desc</th>
                                <th class="f-14">
                                  Order Net Amount Loc Currency
                                </th>
                                <th class="f-14">Error Description</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="(item, index) in itemsNotFoundPo"
                                :key="index"
                              >
                                <td>
                                  {{ item.field['Controlling Area'] || '-' }}
                                </td>
                                <td>
                                  {{ item.field['Internal Order'] || '-' }}
                                </td>
                                <td>
                                  {{ item.field['PO Deletion Flag'] || '-' }}
                                </td>
                                <td>
                                  {{ item.field['PO Number'] || '-' }}
                                </td>
                                <td>
                                  {{ formatDate(item.field['PO-Date']) || '-' }}
                                </td>
                                <td>
                                  {{ item.field['Vendor - Name'] || '-' }}
                                </td>
                                <td>
                                  {{ item.field['PO Line Item Text'] || '-' }}
                                </td>
                                <td>
                                  {{ item.field['PO Release Status'] || '-' }}
                                </td>
                                <td>
                                  {{ item.field['PO Release Flag'] || '-' }}
                                </td>
                                <td>
                                  {{
                                    item.field['Release Indicator-Desc'] || '-'
                                  }}
                                </td>
                                <td class="text-right">
                                  {{
                                    item.field[
                                      'Order Net Amount Loc Currency'
                                    ] || '-'
                                  }}
                                </td>
                                <td>{{ item.error }}</td>
                              </tr>
                            </tbody>
                          </VuePerfectScrollbar>
                        </template>
                      </v-simple-table>
                    </template>
                    <hr class="hr-line mb-5 mt-5" style="" />
                  </v-col>
                </div>
                <div class="px-0" v-if="isErrorIo">
                  <span class="font-weight-medium subtitle-1 darkblue--text">
                    Please check the invalid data IO BI below.
                  </span>
                  <v-col sm="12" class="px-0">
                    <template>
                      <v-simple-table fixed-header class="spending-table">
                        <template v-slot:default>
                          <thead width="100%">
                            <tr>
                              <th class="f-14" width="20%">
                                Controlling Area - Description
                              </th>
                              <th class="f-14" width="40%">
                                Internal Order - Description
                              </th>
                              <th class="f-14">Total</th>
                              <th class="f-14">IO Number</th>
                              <th class="f-14">IO Amount</th>
                            </tr>
                          </thead>
                          <VuePerfectScrollbar
                            class="drawer-menu--scroll"
                            :settings="scrollSettings"
                          >
                            <tbody width="100%">
                              <tr
                                v-for="(item, index) in itemsNotFoundIo"
                                :key="index"
                              >
                                <td width="20%">
                                  {{
                                    item['Controlling Area - Description'] ||
                                      '-'
                                  }}
                                </td>
                                <td width="40%">
                                  {{
                                    item['Internal Order - Description'] || '-'
                                  }}
                                </td>
                                <td class="text-right">
                                  {{ idr(item.Total) }}
                                </td>
                                <td>{{ item.IO }}</td>
                                <td class="text-right">
                                  {{ idr(item['IO Amount']) || '-' }}
                                </td>
                              </tr>
                            </tbody>
                          </VuePerfectScrollbar>
                        </template>
                      </v-simple-table>
                    </template>
                    <hr class="hr-line mb-5 mt-5" style="" />
                  </v-col>
                </div>
                <div class="px-0" v-if="isErrorNonPo">
                  <span class="font-weight-medium subtitle-1 darkblue--text">
                    Please check the invalid Non-PO data below.
                  </span>
                  <v-col sm="12" class="px-0 mb-3">
                    <template>
                      <v-simple-table class="spending-table">
                        <template v-slot:default>
                          <thead width="100%">
                            <tr>
                              <th class="text-left f-14">
                                Internal Order - Description
                              </th>
                              <th class="text-left f-14">ANP Actual Amount</th>
                              <th class="text-left f-14">Error Description</th>
                            </tr>
                          </thead>
                          <VuePerfectScrollbar
                            class="drawer-menu--scroll"
                            :settings="scrollSettings"
                          >
                            <tbody width="100%">
                              <tr
                                v-for="(item, index) in itemsNotFoundNonPo"
                                :key="index"
                              >
                                <td>
                                  {{
                                    item.field.io_number +
                                      ' - ' +
                                      item.field.io_desc || '-'
                                  }}
                                </td>
                                <td class="text-right">
                                  {{ idr(item.field.amount) || '-' }}
                                </td>
                                <td>
                                  {{ item.error }}
                                </td>
                              </tr>
                            </tbody>
                          </VuePerfectScrollbar>
                        </template>
                      </v-simple-table>
                    </template>
                    <hr class="hr-line mb-5 mt-5" style="" />
                  </v-col>
                </div>
                <div class="px-0" v-if="isErrorPoComplete">
                  <span class="font-weight-medium subtitle-1 darkblue--text">
                    Please check the invalid PO Completed data below.
                  </span>
                  <v-col sm="12" class="px-0 mb-3">
                    <template>
                      <v-simple-table class="spending-table">
                        <template v-slot:default>
                          <thead width="100%">
                            <tr>
                              <th class="text-left f-14">Delivery Date</th>
                              <th class="text-left f-14">IO Number</th>
                              <th class="text-left f-14">IO Description</th>
                              <th class="text-left f-14">PO Number</th>
                              <th class="text-left f-14">PO Description</th>
                              <th class="text-left f-14">Error Description</th>
                            </tr>
                          </thead>
                          <VuePerfectScrollbar
                            class="drawer-menu--scroll"
                            :settings="scrollSettings"
                          >
                            <tbody width="100%">
                              <tr
                                v-for="(item,
                                index) in itemsNotFoundPoDescription"
                                :key="index"
                              >
                                <td>
                                  {{
                                    formattedDate(item.field.delivery_date) ||
                                      '-'
                                  }}
                                </td>
                                <td>
                                  {{ item.field.io_number }}
                                </td>
                                <td>
                                  {{ item.field.io_description }}
                                </td>
                                <td>
                                  {{ item.field.po_number || '-' }}
                                </td>
                                <td>
                                  {{ item.field.po_item }}
                                </td>
                                <td>
                                  {{ item.error.join(', ') }}
                                </td>
                              </tr>
                            </tbody>
                          </VuePerfectScrollbar>
                        </template>
                      </v-simple-table>
                    </template>
                    <hr class="hr-line mb-5 mt-5" style="" />
                  </v-col>
                </div>
                <div class="px-0" v-if="isSuccessPoComplete">
                  <span class="font-weight-medium subtitle-1 darkblue--text">
                    This data has been process successfully.
                  </span>
                  <v-col sm="12" class="px-0 mb-3">
                    <template>
                      <v-simple-table class="spending-table">
                        <template v-slot:default>
                          <thead width="100%">
                            <tr>
                              <th class="text-left f-14">Delivery Date</th>
                              <th class="text-left f-14">IO Number</th>
                              <th class="text-left f-14">IO Description</th>
                              <th class="text-left f-14">PO Number</th>
                              <th class="text-left f-14">PO Description</th>
                              <th class="text-left f-14">Complete Status</th>
                            </tr>
                          </thead>
                          <VuePerfectScrollbar
                            class="drawer-menu--scroll"
                            :settings="scrollSettings"
                          >
                            <tbody width="100%">
                              <tr
                                v-for="(item, index) in itemsSuccessPOComplete"
                                :key="index"
                              >
                                <td>
                                  {{
                                    formattedDate(item.field.delivery_date) ||
                                      '-'
                                  }}
                                </td>
                                <td>
                                  {{ item.field.io_number }}
                                </td>
                                <td>
                                  {{ item.field.io_description }}
                                </td>
                                <td>
                                  {{ item.field.po_number || '-' }}
                                </td>
                                <td>
                                  {{ item.field.po_item }}
                                </td>
                                <td>
                                  {{ item.field.complete_status }}
                                </td>
                              </tr>
                            </tbody>
                          </VuePerfectScrollbar>
                        </template>
                      </v-simple-table>
                    </template>
                    <hr class="hr-line mb-5 mt-5" style="" />
                  </v-col>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </ValidationObserver>
      </v-card>
    </v-container>
    <!-- <v-container grid-list-xl fluid class="px-0">
      <v-card class="rounded-10 elevation-card">
        <v-card-title class="primary py-3 px-2 white--text">
          <span
            class="font-weight-700 fs-16 lh-16 pl-1"
            style="align-self: center"
          >
            UPLOAD MONTHLY REPORT
          </span>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-card-text class="px-5 pt-5">
            <v-layout row wrap>
              <v-col class="pl-1">
                <label class="textblack--text fs-12">Upload IO NIS</label>
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzoneNIS"
                  id="dropzone"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterIOMonthlyComplete($event, 'nis', 0)"
                  @vdropzone-reset="fileIORemoved('nis', 0)"
                ></vue-dropzone>
              </v-col>
              <v-col class="pl-1">
                <label class="textblack--text fs-12">Upload IO SH</label>
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzoneSH"
                  id="dropzonePO"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterIOMonthlyComplete($event, 'sh', 1)"
                  @vdropzone-reset="fileIORemoved('sh', 1)"
                ></vue-dropzone>
              </v-col>
              <v-col class="pl-1">
                <label class="textblack--text fs-12">Upload IO NMN</label>
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzoneNMN"
                  id="dropzoneIO"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterIOMonthlyComplete($event, 'nmn', 2)"
                  @vdropzone-reset="fileIORemoved('nmn', 2)"
                ></vue-dropzone>
              </v-col>
              <v-col class="pl-1">
                <label class="textblack--text fs-12">Upload PO NIS</label>
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzonePONIS"
                  id="dropzonePONIS"
                  @vdropzone-complete="afterPOMonthlyComplete($event, 'nis', 0)"
                  @vdropzone-reset="filePORemoved('nis', 0)"
                  :options="dropzoneOptions"
                ></vue-dropzone>
              </v-col>
              <v-col class="px-1">
                <label class="textblack--text fs-12">Upload PO SH</label>
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzonePOSH"
                  id="dropzonePOSH"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterPOMonthlyComplete($event, 'sh', 1)"
                  @vdropzone-reset="filePORemoved('sh', 1)"
                ></vue-dropzone>
              </v-col>
              <v-col class="px-1">
                <label class="textblack--text fs-12">Upload PO NMN</label>
                <vue-dropzone
                  :use-font-awesome="true"
                  ref="myVueDropzonePONMN"
                  id="dropzonePONMN"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterPOMonthlyComplete($event, 'nmn', 2)"
                  @vdropzone-reset="filePORemoved('nmn', 2)"
                ></vue-dropzone>
              </v-col>
              <v-flex xs12 class="px-1">
                <v-btn
                  class="secondblue white--text"
                  block
                  @click="confirmUploadMonthly()"
                  id="uploadAll"
                  >Upload</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </ValidationObserver>
      </v-card>
    </v-container> -->
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import ACLMixin from '../../../mixins/ACLMixin';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    vueDropzone: vue2Dropzone,
    VuePerfectScrollbar
  },
  mixins: [ACLMixin],
  data() {
    return {
      e1: 1,
      steps: 3,
      scrollSettings: {
        maxScrollbarLength: 260
      },
      isDisabled: true,
      isDisabledPO: true,
      isDisabledIO: true,
      isFinish: true,
      loading: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        acceptedFiles: '.xlsx',
        maxFiles: 1,
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Files Here to Upload</span>'
      },
      progressDialogLoading: false,
      search: '',
      isSave: true,
      fiscal: new Date().toISOString().substr(0, 7),
      options: {},
      totalItems: 0,
      xlxFile: {},
      nameFile: '',
      xlxFileBI: ['', '', ''],
      nameFileBI: ['', '', ''],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      breadcrumbs: [
        {
          text: 'SPENDING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'UPLOAD BI DOCUMENT',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Action', value: 'action' }
      ],
      brands: [],
      itemsConvert: [],
      dataBudget: {},
      baseUrl: process.env.VUE_APP_BASE_URL,
      isError: false,
      isErrorPo: false,
      isErrorIo: false,
      isErrorNonPo: false,
      isErrorPoComplete: false,
      isSuccessPoComplete: false,
      itemsNotFound: [],
      itemsNotFoundPo: [],
      itemsNotFoundIo: [],
      itemsNotFoundNonPo: [],
      itemsNotFoundPoDescription: [],
      itemsSuccessPOComplete: [],
      statusSAP: false,
      messageSAP: '',
      messagePO: '',
      messageIO: '',
      messageNon: '',
      messagePOCompleted: '',
      filePOCompleted: null,
      fileMonthly: {
        io: [{ nis: '' }, { sh: '' }, { nmn: '' }],
        po: [{ nis: '' }, { sh: '' }, { nmn: '' }]
      },
      profile_id: null,
      messagePOSH: '',
      messagePONIS: '',
      messagePONMN: '',
      messageIOSH: '',
      messageIONIS: '',
      messageIONMN: '',
      statusPOSH: 'ok',
      statusPONIS: 'ok',
      statusPONMN: 'ok',
      statusIOSH: 'ok',
      statusIONIS: 'ok',
      statusIONMN: 'ok'
    };
  },
  mounted() {
    this.profile_id = localStorage.getItem('profile_id');
  },
  computed: {
    statusUpload() {
      if (
        this.statusPOSH === 'ok' &&
        this.statusPONIS === 'ok' &&
        this.statusPONMN === 'ok' &&
        this.statusIOSH === 'ok' &&
        this.statusIONIS === 'ok' &&
        this.statusIONMN === 'ok'
      )
        return true;
      return false;
    }
  },
  methods: {
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    prevStep(n) {
      this.e1 = n - 1;
    },
    afterComplete(file) {
      this.isError = false;
      this.isErrorPo = false;
      this.isErrorIo = false;
      this.isErrorNonPo = false;
      this.itemsNotFound = [];
      this.isDisabled = false;
      this.xlxFile = file;
      this.nameFile = file.upload.filename;
    },
    afterPOCompleted(file) {
      this.filePOCompleted = file;
    },
    fileRemovedPO() {
      this.filePOCompleted = null;
      this.isErrorPoComplete = false;
      this.isSuccessPoComplete = false;
      this.itemsNotFoundPoDescription = [];
      this.itemsSuccessPOComplete = [];
      this.$refs.myVueDropzone.removeAllFiles();
    },
    afterCompleteBI(file, index) {
      this.isError = false;
      this.isErrorPo = false;
      this.isErrorIo = false;
      this.isErrorNonPo = false;
      if (index == 0) {
        this.isDisabledPO = false;
      } else {
        this.isDisabledIO = false;
      }
      this.xlxFileBI[index] = file;
      this.nameFileBI[index] = file.upload.filename;
    },
    fileRemoved() {
      this.isError = false;
      this.itemsNotFound = [];
      this.nameFile = '';
      this.xlxFile = '';
      this.$refs.myVueDropzone.removeAllFiles();
    },
    fileRemovedBI(index) {
      this.xlxFileBI[index] = '';
      this.nameFileBI[index] = '';
      if (index === 0) {
        this.$refs.myVueDropzonePO.removeAllFiles();
      } else if (index === 1) {
        this.$refs.myVueDropzoneIO.removeAllFiles();
      } else if (index === 2) {
        this.$refs.myVueDropzoneNonPO.removeAllFiles();
      }
      if (this.xlxFile.length > 0) {
        this.isDisabledBI = true;
      }
    },
    afterPOMonthlyComplete(file, type, index) {
      this.fileMonthly.po[index][type] = file;
    },
    filePORemoved(type, index) {
      this.fileMonthly.po[index][type] = '';
      if (index === 0) {
        this.$refs.myVueDropzonePONIS.removeAllFiles();
      } else if (index === 1) {
        this.$refs.myVueDropzonePOSH.removeAllFiles();
      } else if (index === 2) {
        this.$refs.myVueDropzonePONMN.removeAllFiles();
      }
    },
    afterIOMonthlyComplete(file, type, index) {
      this.fileMonthly.io[index][type] = file;
    },
    fileIORemoved(type, index) {
      this.fileMonthly.io[index][type] = '';
      if (index === 0) {
        this.$refs.myVueDropzoneIONIS.removeAllFiles();
      } else if (index === 1) {
        this.$refs.myVueDropzoneIOSH.removeAllFiles();
      } else if (index === 2) {
        this.$refs.myVueDropzoneIONMN.removeAllFiles();
      }
    },
    confirmUploadMonthly() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to upload monthly report?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.uploadMonthly();
        }
      });
    },
    async uploadMonthly() {
      this.statusPOSH = 'ok';
      this.statusPONIS = 'ok';
      this.statusPONMN = 'ok';
      this.statusIOSH = 'ok';
      this.statusIONIS = 'ok';
      this.statusIONMN = 'ok';
      this.messagePOSH = '';
      this.messagePONIS = '';
      this.messagePONMN = '';
      this.messageIOSH = '';
      this.messageIONIS = '';
      this.messageIONMN = '';
      await this.uploadPOMonthly();
      await this.uploadIOMonthly();
      if (
        this.messagePOSH === '' &&
        this.messagePONIS === '' &&
        this.messagePONMN === '' &&
        this.messageIOSH === '' &&
        this.messageIONIS === '' &&
        this.messageIONMN === ''
      ) {
        Swal.fire(
          'Failed!',
          'You need input the file at least 1 file',
          'error'
        );
      } else {
        Swal.fire(
          'Upload Status',
          `<div style="text-align: left">
          <span>${this.messagePOSH}</span>` +
            `<span>${this.messagePONIS}</span>` +
            `<span>${this.messagePONMN}</span>` +
            `<span>${this.messageIOSH}</span>` +
            `<span>${this.messageIONIS}</span>` +
            `<span>${this.messageIONMN}</span>`,
          this.statusUpload ? 'success' : 'info'
        );
      }
      this.$refs.myVueDropzonePONIS.removeAllFiles();
      this.$refs.myVueDropzonePOSH.removeAllFiles();
      this.$refs.myVueDropzonePONMN.removeAllFiles();
      this.$refs.myVueDropzoneNIS.removeAllFiles();
      this.$refs.myVueDropzoneSH.removeAllFiles();
      this.$refs.myVueDropzoneNMN.removeAllFiles();
      this.fileMonthly = {
        io: [{ nis: '' }, { sh: '' }, { nmn: '' }],
        po: [{ nis: '' }, { sh: '' }, { nmn: '' }]
      };
    },
    async uploadPOMonthly() {
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      for (let i = 0; i < this.fileMonthly.po.length; i++) {
        let obj = Object.keys(this.fileMonthly.po[i])[0];
        if (this.fileMonthly.po[i][obj] !== '') {
          var fileType = this.fileMonthly.po[i][obj].upload.filename
            .split('.')
            .pop();
          if (fileTypes.includes(fileType)) {
            this.progressDialogLoading = true;
            let formData = new FormData();
            formData.append('io', this.fileMonthly.po[i][obj]);
            let params = {
              profileId: this.profile_id,
              entity: obj.toUpperCase()
            };
            await this.$store
              .dispatch('monthlyReport/uploadPO', {
                payload: formData,
                params: params
              })
              .then(data => {
                this.progressDialogLoading = false;
                this.loading = false;
                if (data.code === 200) {
                  if (obj === 'sh') {
                    this.statusPOSH = data.status.toLowerCase();
                    this.messagePOSH = `Source PO SH : ${data.message.text_en}.<br>`;
                  } else if (obj === 'nis') {
                    this.statusPONIS = data.status.toLowerCase();
                    this.messagePONIS = `Source PO NIS : ${data.message.text_en}.<br>`;
                  } else {
                    this.statusPONMN = data.status.toLowerCase();
                    this.messagePONMN = `Source PO NMN : ${data.message.text_en}.<br>`;
                  }
                } else {
                  if (obj === 'sh') {
                    this.statusPOSH = data.response.data.status.toLowerCase();
                    this.messagePOSH = `Source PO SH : ${data.response.data.message.text_en}<br>`;
                  } else if (obj === 'nis') {
                    this.statusPONIS = data.response.data.status.toLowerCase();
                    this.messagePONIS = `Source PO NIS : ${data.response.data.message.text_en}<br>`;
                  } else {
                    this.statusPONMN = data.response.data.status.toLowerCase();
                    this.messagePONMN = `Source PO NMN : ${data.response.data.message.text_en}<br>`;
                  }
                }
              })
              .catch(error => {
                console.log('error', error.response);
                this.progressDialogLoading = false;
                if (obj === 'sh') {
                  this.statusPOSH = error.response.data.status.toLowerCase();
                  this.messagePOSH = `Source PO SH : ${error.response.data.message.text_en}.<br>`;
                } else if (obj === 'nis') {
                  this.statusPONIS = error.response.data.status.toLowerCase();
                  this.messagePONIS = `Source PO NIS : ${error.response.data.message.text_en}.<br>`;
                } else {
                  this.statusPONMN = error.response.data.status.toLowerCase();
                  this.messagePONMN = `Source PO NMN : ${error.response.data.message.text_en}.<br>`;
                }
              });
          }
        }
      }
    },
    async uploadIOMonthly() {
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      for (let i = 0; i < this.fileMonthly.io.length; i++) {
        let obj = Object.keys(this.fileMonthly.io[i])[0];
        if (this.fileMonthly.io[i][obj] !== '') {
          var fileType = this.fileMonthly.io[i][obj].upload.filename
            .split('.')
            .pop();
          if (fileTypes.includes(fileType)) {
            this.progressDialogLoading = true;
            let formData = new FormData();
            formData.append('io', this.fileMonthly.io[i][obj]);
            let params = {
              profileId: this.profile_id,
              entity: obj.toUpperCase()
            };
            await this.$store
              .dispatch('monthlyReport/uploadIO', {
                payload: formData,
                params: params
              })
              .then(data => {
                this.progressDialogLoading = false;
                this.loading = false;
                if (data.code === 200) {
                  if (obj === 'sh') {
                    this.statusIOSH = data.data.status;
                    this.messageIOSH = `Source IO SH : ${data.message.text_en}.<br>`;
                  } else if (obj === 'nis') {
                    this.statusIONIS = data.data.status;
                    this.messageIONIS = `Source IO NIS : ${data.message.text_en}.<br>`;
                  } else {
                    this.statusIONMN = data.data.status;
                    this.messageIONMN = `Source IO NMN : ${data.message.text_en}.<br>`;
                  }
                } else {
                  if (obj === 'sh') {
                    this.statusIOSH = data.status;
                    this.messageIOSH = `Source IO SH : ${data.response.data.message.text_en}<br>`;
                  } else if (obj === 'nis') {
                    this.statusIONIS = data.status;
                    this.messageIONIS = `Source IO NIS : ${data.response.data.message.text_en}<br>`;
                  } else {
                    this.statusIONMN = data.status;
                    this.messageIONMN = `Source IO NMN : ${data.response.data.message.text_en}<br>`;
                  }
                }
              })
              .catch(error => {
                this.progressDialogLoading = false;
                if (obj === 'sh') {
                  this.statusIOSH = error.response.data.status;
                  this.messageIOSH = `Source IO SH : ${error.response.data.message.text_en}.<br>`;
                } else if (obj === 'nis') {
                  this.statusIONIS = error.response.data.status;
                  this.messageIONIS = `Source IO NIS : ${error.response.data.message.text_en}.<br>`;
                } else {
                  this.statusIONMN = error.response.data.status;
                  this.messageIONMN = `Source IO NMN : ${error.response.data.message.text_en}.<br>`;
                }
              });
          }
        }
      }
    },
    async uploadCompleted() {
      var fileType = this.filePOCompleted.upload.filename.split('.').pop();
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      if (fileTypes.includes(fileType)) {
        this.progressDialogLoading = true;
        let formData = new FormData();
        formData.append('upload', this.filePOCompleted);
        await this.$store
          .dispatch('purchasingOrder/uploadPoComplete', formData)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              this.isDisabled = true;
              this.clear();
              this.fileRemoved();
              if (data.data.result.length > 0) {
                this.statusSAP = true;
                this.messagePOCompleted = `Source PO Completed : ${data.message.text_en}.<br>`;
                this.isErrorPoComplete = false;
                this.isSuccessPoComplete = true;
                this.itemsSuccessPOComplete = data.data.result;
              }
              if (data.data.dataNotfound.length > 0) {
                this.statusSAP = false;
                this.fileRemovedBI(0);
                this.fileRemovedBI(1);
                this.fileRemovedBI(2);
                this.messagePOCompleted = `Source PO Completed : ${data.message.text_en}<br>`;
                this.isErrorPoComplete = true;
                this.itemsNotFoundPoDescription = data.data.dataNotfound;
              }
            } else {
              this.messagePOCompleted = `Source PO Completed : ${data.response.data.message.text_en}<br>`;
            }
          })
          .catch(error => {
            this.messagePOCompleted = `Source PO Completed : ${error.response.data.message.text_en}<br>`;
            this.fileRemovedBI(0);
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.messagePOCompleted = `Source PO Completed : failed upload format file must be .xlsx!<br>`;
        this.fileRemovedBI(0);
      }
    },
    async uploadFile() {
      this.statusSAP = false;
      var fileType = this.nameFile.split('.').pop();
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      if (fileTypes.includes(fileType)) {
        this.progressDialogLoading = true;
        this.loading = true;
        this.isSave = false;
        let formData = new FormData();
        formData.append('uploadSAP', this.xlxFile);
        await this.$store
          .dispatch('spending/uploadSAP', formData)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              this.itemsConvert = data.data;
              this.isDisabled = true;
              this.clear();
              this.fileRemoved();
              if (data.data.dataNotfound.length === 0) {
                this.statusSAP = true;
                this.messageSAP = `IO SAP : ${data.message.text_en}.<br>`;
                this.isError = false;
              } else {
                if (data.data.dataNotfound) {
                  this.statusSAP = false;
                  this.fileRemovedBI(0);
                  this.fileRemovedBI(1);
                  this.fileRemovedBI(2);
                  this.messageSAP = `IO SAP : ${data.message.text_en}<br>`;
                  this.isError = true;
                  this.itemsNotFound = data.data.dataNotfound;
                }
              }
            } else {
              this.statusSAP = false;
              this.fileRemovedBI(0);
              this.fileRemovedBI(1);
              this.fileRemovedBI(2);
              this.fileRemoved();
              this.messageSAP = `IO SAP : ${data.response.data.message.text_en}<br>`;
            }
          })
          .catch(err => {
            this.messageSAP = `IO SAP : ${err.response.data.message.text_en}<br>`;
            this.progressDialogLoading = false;
            this.loading = false;
            this.fileRemoved();
          });
      } else {
        this.messageSAP = `IO SAP : failed upload format file must be .xlsx!<br>`;
        this.fileRemoved();
      }
    },
    async uploadPo() {
      var fileType = this.nameFileBI[0].split('.').pop();
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      if (fileTypes.includes(fileType)) {
        this.progressDialogLoading = true;
        this.loading = true;
        let formData = new FormData();
        formData.append('uploadSAP', this.xlxFileBI[0]);
        await this.$store
          .dispatch('spending/uploadPO', formData)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              this.fileRemovedBI(0);
              if (data.data.dataNotfound.length === 0) {
                this.messagePO = `Source PO BI : ${data.message.text_en}.<br>`;
                this.isErrorPo = false;
                this.nextStep(this.e1);
              } else {
                if (data.data.dataNotfound) {
                  this.messagePO = `Source PO BI : ${data.message.text_en}<br>`;
                  this.isErrorPo = true;
                  this.itemsNotFoundPo = data.data.dataNotfound;
                }
              }
            } else {
              this.messagePO = `Source PO BI : ${data.response.data.message.text_en}<br>`;
              this.fileRemovedBI(0);
            }
          })
          .catch(error => {
            this.messagePO = `Source PO BI : ${error.response.data.message.text_en}<br>`;
            this.fileRemovedBI(0);
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.messagePO = `Source PO BI : failed upload format file must be .xlsx!<br>`;
        this.fileRemovedBI(0);
      }
    },
    async uploadNonPo() {
      var fileType = this.nameFileBI[2].split('.').pop();
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      if (fileTypes.includes(fileType)) {
        this.progressDialogLoading = true;
        this.loading = true;
        let formData = new FormData();
        formData.append('upload', this.xlxFileBI[2]);
        await this.$store
          .dispatch('spending/uploadNonPo', formData)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              this.$refs.myVueDropzoneNonPO.removeAllFiles();
              this.xlxFileBI[2] = '';
              this.nameFileBI[2] = '';
              if (data.data.dataNotfound.length === 0) {
                this.messageNon = `Source Non-PO BI : ${data.message.text_en}.<br>`;
                this.isErrorNonPo = false;
                this.nextStep(this.e1);
              } else {
                if (data.data.dataNotfound) {
                  this.messageNon = `Source Non-PO BI : ${data.message.text_en}<br>`;
                  this.isErrorNonPo = true;
                  this.itemsNotFoundNonPo = data.data.dataNotfound;
                }
              }
            } else {
              this.messageNon = `Source Non-PO BI : ${data.response.data.message.text_en}<br>`;
              this.$refs.myVueDropzoneNonPO.removeAllFiles();
            }
          })
          .catch(error => {
            this.messageNon = `Source Non-PO BI : ${error.response.data.message.text_en}<br>`;
            this.$refs.myVueDropzoneNonPO.removeAllFiles();
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.messageNon = `Source Non-PO BI : failed upload format file must be .xlsx<br>`;
        this.$refs.myVueDropzoneNonPO.removeAllFiles();
      }
    },
    async getTemplateUpload(val) {
      const res = await this.$store.dispatch('monthlyReport/getTemplate', {
        type: val
      });
      console.log(res);
      const url = URL.createObjectURL(
        new Blob([res], {
          type: 'application/vnd.ms-excel'
        })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `template-${val}.xlsx`);
      document.body.appendChild(link);
      link.click();
    },
    async uploadIo() {
      var fileType = this.nameFileBI[1].split('.').pop();
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      if (fileTypes.includes(fileType)) {
        this.progressDialogLoading = true;
        this.loading = true;
        let formData = new FormData();
        formData.append('uploadIoBI', this.xlxFileBI[1]);
        await this.$store
          .dispatch('spending/uploadIO', formData)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              this.$refs.myVueDropzoneIO.removeAllFiles();
              this.isDisabledIO = true;
              this.xlxFileBI[1] = '';
              this.nameFileBI[1] = '';
              if (data.data.dataNotMatch.length === 0) {
                this.messageIO = `Source IO BI : ${data.message.text_en}.<br>`;
                this.isErrorIo = false;
                this.isFinish = false;
              } else {
                if (data.data.dataNotMatch) {
                  this.messageIO = `Source IO BI : ${data.message.text_en}<br>`;
                  this.isErrorIo = true;
                  this.itemsNotFoundIo = data.data.dataNotMatch;
                }
              }
            } else {
              this.messageIO = `Source IO BI : ${data.response.data.message.text_en}<br>`;
              this.$refs.myVueDropzoneIO.removeAllFiles();
            }
          })
          .catch(error => {
            this.messageIO = `Source IO BI : ${error.response.data.message.text_en}<br>`;
            this.$refs.myVueDropzoneIO.removeAllFiles();
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.messageIO = `Source IO BI : failed upload format file must be .xlsx!<br>`;
        this.$refs.myVueDropzoneIO.removeAllFiles();
      }
    },
    async uploadAll() {
      this.isError = false;
      this.isErrorPo = false;
      this.isErrorIo = false;
      this.isErrorNonPo = false;
      this.isErrorPoComplete = false;
      this.itemsNotFound = [];
      this.itemsNotFoundPo = [];
      this.itemsNotFoundIo = [];
      this.itemsNotFoundNonPo = [];
      this.itemsNotFoundPoDescription = [];
      this.itemsSuccessPOComplete = [];
      this.messageSAP = '';
      this.messagePO = '';
      this.messageIO = '';
      this.messageNon = '';
      this.messagePOCompleted = '';
      if (this.filePOCompleted) {
        await this.uploadCompleted();
      }
      if (this.nameFile !== '') {
        await this.uploadFile();
        if (this.statusSAP) {
          await this.uploadBI();
        }
      } else {
        await this.uploadBI();
      }
      Swal.fire(
        'Upload Status',
        `<div style="text-align: left">
        <span>${this.messageSAP}</span>` +
          `<span>${this.messagePO}</span>` +
          `<span>${this.messageIO}</span>` +
          `<span>${this.messageNon}</span>` +
          `<span>${this.messagePOCompleted}</span></div>`,
        'info'
      );
    },
    async uploadBI() {
      if (this.xlxFileBI[0] !== '') {
        await this.uploadPo();
      }
      if (this.xlxFileBI[1] !== '') {
        await this.uploadIo();
      }
      if (this.xlxFileBI[2] !== '') {
        await this.uploadNonPo();
      }
    },
    clear() {
      this.xlxFile = {};
      this.nameFile = '';
    }
  }
};
</script>
<style scoped lang="css">
.border-dot {
  border-style: dotted;
  border-width: 2px;
  border-color: #d3d3d385;
  border-radius: 10px;
}
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid #d8d8d8;
}
.drawer-menu--scroll {
  max-height: 250px;
  overflow: auto;
}
.table-taxonomy::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
}
.table-taxonomy::-webkit-scrollbar-thumb {
  background: #cccc !important;
}
.table-taxonomy::-webkit-scrollbar-thumb:window-inactive {
  background: #d8d8d8 !important;
}
tr:hover {
  background-color: #f5f5f5 !important;
}
</style>
